// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"86c75b53","455":"36be17fc","977":"87e53517"}[chunkId] + ".chunk.js";
};